import { type OauthToken, createOauthToken } from 'models';

import { useMutation } from 'query';
import { loginWithToken } from '../../services';

const defaultMutateOnError = () => {
  // Do nothing
  // This mutation is used within other mutation that handle error already
};

export const useLoginWithTokenQuery = () =>
  useMutation<OauthToken, { token: string; type?: 'magic_token' }>({
    defaultMutateOnError,
    async mutationFn({ token, type }) {
      const oauthResponse = await loginWithToken({
        /* eslint-disable @typescript-eslint/naming-convention -- key is defined by Backend API endpoint */
        grant_type: 'password',
        login_token: token,
        login_token_type: type,
        /* eslint-enable @typescript-eslint/naming-convention -- key is defined by Backend API endpoint */
      });

      return createOauthToken(oauthResponse.data);
    },
  });
